import { motion } from "framer-motion";
import { FAMILIAR_LINES } from "../content";

export default function SoundFamiliar() {
  return (
    <section data-testid="sound-familiar-section" className="py-28 md:py-36 px-4 sm:px-6 max-w-5xl mx-auto">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="font-mono text-xs tracking-[0.35em] text-gold mb-6"
      >
        01 — SOUND FAMILIAR?
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.1 }}
        className="font-serif text-3xl sm:text-4xl md:text-5xl font-light tracking-tight mb-16 md:mb-20"
      >
        Sound familiar?
      </motion.h2>

      <div className="space-y-10 max-w-3xl">
        {FAMILIAR_LINES.map((s, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.15 }}
            className="group border-l border-border pl-6 hover:border-gold transition-colors duration-500"
            data-testid={`familiar-line-${i}`}
          >
            <p className="font-serif text-xl sm:text-2xl font-light leading-snug text-bone/85 group-hover:text-bone transition-colors duration-500">
              {s}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
